
import product from '~/mixins/product'
import productAddedToCart from '~/mixins/productAddedToCart'
import gtm from '~/mixins/gtm'

export default {
  name: 'ProductPhysicalMain',
  mixins: [
    product,
    productAddedToCart,
    gtm,
  ],

  props: {
    product: {
      type: Object,
      required: true,
    },

    productReviews: {
      type: Array,
      default: () => [],
    },
  },

  data () {
    return {
      selectedVariantSlug: '',
      quantity: 1,
      isModalOpen: false,
      price: null,
    }
  },

  computed: {
    variants () {
      return this.product.options?.find(({ _typename }) => _typename === 'CustomizableRadioOption')?.value
    },

    optionLink () {
      return this.product.options?.find(({ _typename }) => _typename === 'CustomizableDropDownOption')
    },

    cartItems () {
      const slug = this.selectedVariantSlug || this.$route.query.variant || ''

      const variant = this.variants?.find(({ slug: itemSlug }) => itemSlug === slug) || {}
      const { optionId = null, optionTypeId = null } = variant

      const { optionId: optionIdLink, value: optionValue } = this.optionLink || {}
      const optionTypeIdLink = optionValue?.[0]?.optionTypeId || null

      const customizableOptions = [
        {
          id: optionId,
          valueString: optionTypeId?.toString() || '',
        },
      ]

      if (optionIdLink && optionTypeIdLink) {
        customizableOptions.push({
          id: optionIdLink,
          valueString: optionTypeIdLink.toString(),
        })
      }

      return [
        {
          data: {
            sku: this.product?.sku || '',
            quantity: this.quantity || 1,
          },

          customizableOptions,
        },
      ]
    },
  },

  methods: {
    async onAddedToCart (payload) {
      await this.$cart.addedToCart(payload)

      this.isModalOpen = true
      this.gtm('add_to_cart', this.getProduct(), this.quantity, null, null)
    },

    getProduct () {
      const {
        product: { name, _typename },
        quantity,
        price: { lowestPriceHistory, price, finalPrice, mediclubPrice },
      } = this

      const calculatePrice = priceObj => priceObj && ({ ...priceObj, value: priceObj.value * quantity })

      const calculatedPrice = {
        lowestPrice: calculatePrice(lowestPriceHistory),
        regular: calculatePrice(price),
        final: finalPrice ? finalPrice * quantity : null,
        mediclub: calculatePrice(mediclubPrice),
      }

      return {
        name,
        quantity,
        hasMaterialFee: false,
        _typename,
        price: calculatedPrice,
      }
    },

    jsonld () {
      return {
        '@context': 'https://schema.org',
        '@type': 'Product',
        gtin: this.product.internationalCode,
      }
    },

  },
}
